import { Component, OnInit, Input } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { DomSanitizer } from '@angular/platform-browser';
import { ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { Lightbox } from 'ngx-lightbox';

import { environment } from '@environments/environment';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.less']
})
export class ServiceComponent implements OnInit {
  @Input() service: any;
  @Input() quotationId: any;
  @Input() versionId: any;
  @Input() quotation: any;
  @Input() project: any;

  // doublon check validated dans chapter
  public isDesktop = false;
  public user: any;
  public materials: any;
  public stepIsAgreementOrDesign:boolean;

  constructor(
    private requestService: RequestService,
    breakpointObserver: BreakpointObserver,
    public globalDataService: GlobalDataService,
    private scrollToService: ScrollToService,
    private sanitization: DomSanitizer,
    private requestV2Service: RequestV2Service,
    private lightbox: Lightbox
  ) {
    breakpointObserver.observe(['(min-width: 800px)']).subscribe((result) => {
      this.isDesktop = result.matches;
      this.user = this.globalDataService.getUser();
    });
  }

  async ngOnInit() {
    this.stepIsAgreementOrDesign = this.checkAgreementOrDesignStep();

    const materialsResult = await this.requestV2Service
      .getQuotationMaterials(this.service.id, null, true, 'all', 'false');

    this.materials = materialsResult.items;
  }

  private checkAgreementOrDesignStep() {
    const steps = this.globalDataService.steps
      .filter(pS => pS.slug === 'agreement_signed' || pS.slug === 'design').map(pS => pS.id);

    return steps.includes(this.project.id_project_step);
  }

  public calculateUnitServicePrice(): number {
    if (this.globalDataService.financial) {
      const findChapter = this.globalDataService.financial.customer.chapters
        .find(i => i.id_quotation_chapter === this.service.id_quotation_chapter);

      if (findChapter) {
        const service = findChapter.services.find(i => i.id_quotation_service === this.service.id);

        return service.total;
      }
    }

    return 0;
  }

  // doublon check validated dans chapter
  public checkValidated(validated: boolean): any {
    return !validated ? 'quot-service-grayed' : '';
  }

  public getColSpan(): number {
    if (!this.isDesktop) {
      return 6;
    }
    const length = this.materials.length;
    if (length > 2) {
      return 2;
    }
    return 3;
  }

  public getPhoto(id): string {
    let result;
    if (typeof id !== 'undefined') {
      result = this.sanitization
        .bypassSecurityTrustUrl(
          `${environment.api_url}/images/${id}?size=70x70`
        );
    }
    return result;
  }

  openPhoto(material) {
    const photosToOpen = [];
    if (material
      && material._related
      && material._related.material_version_images) {
      material._related.material_version_images.forEach((photo) => {
        photosToOpen.push({
          src: `${environment.api_url}/images/${photo.id_image}?size=350x650`,
          thumb: photo.id_image
        });
      });
    }
    this.lightbox.open(photosToOpen, 0, { wrapAround: true, showImageNumberLabel: true });
  }

  public isOption(): boolean {
    return this.service.type.includes('option');
  }
}
